import {
  ComboBox,
  ContextualMenu,
  DetailsListLayoutMode,
  Dialog,
  DialogFooter,
  FontSizes,
  FontWeights,
  getTheme,
  IButtonStyles,
  IColumn,
  IComboBox,
  IComboBoxOption,
  ICommandBarItemProps,
  Icon,
  IconButton,
  IDragOptions,
  IIconProps,
  mergeStyleSets,
  MessageBar,
  MessageBarButton,
  MessageBarType,
  Modal,
  NeutralColors,
  PanelType,
  Pivot,
  PivotItem,
  PrimaryButton,
  ProgressIndicator,
  SharedColors,
  TextField,
  TooltipHost,
} from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  IListaCuenta,
  IListaRol,
  IUserById,
} from "../../../Interfaces/IUsuario";
import usuarioServicio from "../../../services/usuarioService";
import axios from "axios";
import { TableBase } from "../../../components/Table/TableBase";
import IconHelper from "../../../utils/helpers/iconHelper";
import { IPagination } from "../../../Interfaces/base/ITable";
import {
  _initialFilter,
  _initialPagination,
} from "../../../utils/helpers/helpers";
import { Ifilter } from "../../../Interfaces/filter";
import { ConfigHelper } from "../../../utils/helpers/configHelper";
import { PanelAsignacionRoles } from "./PanelAsignacionRoles";
import { PanelEliminarRol } from "./PanelEliminarRol";
import { PanelEliminarCuenta } from "./PanelEliminarCuenta";
import { PanelAsignarCuenta } from "./PanelAsignarCuenta";
export interface ICuentasUser {
  usuarioId: string;
}

const CuentasUser = (props: ICuentasUser) => {
  const navigate = useNavigate();
  const state = useLocation();
  const usuarioState: any = state.state;
  const usuarioId =
    usuarioState && usuarioState != null ? usuarioState.usuarioId : "";
  const identityId =
    usuarioState && usuarioState != null ? usuarioState.identityId : "";

  // const [info, setInfo] = useState<IPersona>(null!);
  const [cargaTabla, setCargaTabla] = useState(false);

  const [totalItems, setTotalItems] = useState(0);
  const [itemsView, setitemsView] = useState(50);
  const [item, setItem] = useState<IListaCuenta[]>([]);
  // const persona: IPersona = state.state;
  // const [personaId, setPersonaId] = useState<string>(persona?.personaId ?? "");
  const controllerRef = useRef<AbortController>(new AbortController());

  const [
    isOpenAsignarRol,
    { setTrue: openPanelAsignarRol, setFalse: dismissPanelAsignarRol },
  ] = useBoolean(false);
  // const [filter, setFilter] = useState<IFilter>({
  //   skip: 0,
  //   take: 50,
  //   search: "",
  // });

  const [
    isOpenPanelEliminarCuenta,
    { setTrue: openPanelEliminarCuenta, setFalse: dismissPanelEliminarCuenta },
  ] = useBoolean(false);

  // const [modelUpdatePersonaRol, setModelUpdatePersonaRol] =
  //   useState<IUpdateUsuarioRol>({
  //     personaId: personaId,
  //   });

  const [keepInBounds, { toggle: toggleKeepInBounds }] = useBoolean(false);

  //panel
  const [isOpenCrear, { setTrue: openCrear, setFalse: dismissCrear }] =
    useBoolean(false);

  /* ------------- mensajes de estado -------------- */
  const [verLoading, setVerLoading] = useState(false);
  const [mensajeTransaccion, setMensajeTransaccion] = useState("");
  const [tipoMensaje, setTipoMensaje] = useState(0);
  const [verLoadingBoton, setVerLoadingBoton] = useState(false);
  const [activo, setActivo] = useState<boolean>(true);

  //aca
  const [filter, setFilter] = useState<Ifilter>(_initialFilter);
  const [cuentaSelected, setCuentaSelected] = useState<IListaCuenta>(null!);

  // useEffect(() => {
  //   if (personaId != "") {
  //     _alterTabla();
  //     dataPersona();
  //   } else {
  //     navigate(`/ssoma/personas/listado`);
  //   }
  // }, []);

  // const dataPersona = () => {
  //   if (persona && persona.personaId != "") {
  //     personaTokenService
  //       .personaByID(personaId)
  //       .then((res) => {
  //         if (res.status === 200) {
  //           setInfo(res.data);
  //         }
  //       })
  //       .catch((e: IException) => {
  //         alert(splitExceptionDetail(e));
  //       });
  //   }
  // };

  useEffect(() => {
    getCuentasByUser();
  }, []);

  const getCuentasByUser = () => {
    setCargaTabla(true);

    usuarioServicio
      .listarCuentasPorUsuario(props.usuarioId)
      .then((res) => {
        if (res.status == 200) {
          // setIdentityId(res.data?.identityId);
          setItem(res.data);
          setTotalItems(res.data?.length);
          setCargaTabla(false);
        }
      })
      .catch((e) => {
        if (axios.isCancel(e)) {

        } else {
          console.error("Error en la solicitud:", e?.message);
          setCargaTabla(false);
        }
      });
  };

  const _leftBar = () => {
    const _items: ICommandBarItemProps[] = [
      {
        ...IconHelper.ICON_BACK,
        onClick: () => {
          navigate(ConfigHelper.urlBase() + "/configuraciones/usuarios");
        },
      },
      {
        ...IconHelper.ICON_RELOAD,
        onClick: () => getCuentasByUser(),
      },
      {
        ...IconHelper.ICON_ADD_TABLE,
        onClick: () => openCrear(),
      },
    ];

    return _items;
  };

  const _column: IColumn[] = [
    {
      key: "cuenta",
      name: "Cuenta",
      fieldName: "cuenta",
      minWidth: 30,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "creacion",
      name: "Fecha Creacion",
      fieldName: "creacion",
      minWidth: 30,
      maxWidth: 150,
      isResizable: true,
    },

    {
      key: "column3",
      name: "Opciones",
      fieldName: "",
      minWidth: 40,
      maxWidth: 100,
      isResizable: true,
      onRender: (item) => {
        return (
          <>
            <div>
              <TooltipHost content="Eliminar">
                <Icon
                  style={{
                    color: SharedColors.red10,
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                  iconName="Delete"
                  onClick={() => {
                    setCuentaSelected(item);
                    openPanelEliminarCuenta();
                  }}
                />
              </TooltipHost>
            </div>
          </>
        );
      },
    },
  ];

  const [currentPage, setCurrentPage] = React.useState(
    _initialPagination().currentPage
  );
  const [pageSize, setPageSize] = React.useState(_initialPagination().pageSize);

  const [pagIngreso, setPagIngreso] = React.useState<IPagination>({
    ..._initialPagination(),
    onPageChange: (page) => setCurrentPage(page),
    onSizeChange: (pageSize) => setPageSize(pageSize),
  });

  const _getPageSize = (value: number) => {
    setPageSize(value);
    setFilter({ ...filter, skip: (currentPage - 1) * pageSize, take: value });
    setPagIngreso({ ...pagIngreso, pageSize: value });
  };

  return (
    <>
      {/* <pre>{JSON.stringify(props.usuarioId, null, 2)}</pre> */}
      <TableBase
        leftBar={_leftBar()}
        isLoading={cargaTabla}
        pagination={pagIngreso}
        data={item}
        getPageSize={_getPageSize}
        column={_column}
        layout={DetailsListLayoutMode.justified}
      />

      <div style={{ position: "absolute", bottom: 10, right: 0 }}>
        {/* <PaginationV9
                  setFilter={setFilter}
                  filter={filter}
                  setItemsView={setitemsView}
                  itemsView={itemsView}
                  totalData={totalItems}
                /> */}
      </div>

      {/* <PanelAsignacionRoles
              usuarioId={usuarioId}
              identityId={identityId}
              isOpen={isOpenAsignarRol}
              onDismiss={dismissPanelAsignarRol}
              onRenderTable={getCuentasByUser}
              roles={item.map((x) => x.key.toLowerCase())}
            /> */}

      <PanelEliminarCuenta
        cuenta={cuentaSelected}
        isOpen={isOpenPanelEliminarCuenta}
        onDismiss={dismissPanelEliminarCuenta}
        onRenderTable={getCuentasByUser}
      />

      <PanelAsignarCuenta
        onDismiss={dismissCrear}
        isOpen={isOpenCrear}
        onRenderTable={getCuentasByUser}
        usuarioId={props.usuarioId}
      />

      {/* <PanelEliminarRol
                onDismiss={dismissPanelEliminar}
                isOpen={isOpenPanelEliminar}
                reload={loadTablaCuentasUsuario}
                deleteRol={modelUpdatePersonaRol}
                identityId={identityId.toLowerCase()}
              /> */}
    </>
  );
};

export { CuentasUser };
